import React, { useEffect, useState } from 'react';
import { getProjectList } from '../../../api/portfolio';

function Portfolio() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getProjectList()
      .then(setProjects)
      .catch((err) => setError(err.message || 'Failed to load projects'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="sec-box portfolio section-padding" id="portfolio">
      <div className="sec-head mb-30">
        <div className="row">
          <div className="col-lg-6">
            <h6 className="sub-title opacity-7 mb-15">Projects</h6>
            <h3>
              Look at my school work & <br />{' '}
              <span className="main-color">Free-time projects</span>
            </h3>
          </div>
          <div className="col-lg-6 valign">
            <div className="go-more full-width d-flex justify-content-end">
              <a href="/works" className="d-flex">
                <span>
                  View All Works{' '}
                  <svg
                    className="arrow-right"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 34.2 32.3"
                    xmlSpace="preserve"
                    style={{ strokeWidth: 2 }}
                  />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="gallery">
        <div className="row">
          {loading && (
            <div className="col-12">
              <p className="opacity-7">Loading projects...</p>
            </div>
          )}
          {error && !loading && (
            <div className="col-12">
              <p className="opacity-7">Could not load projects: {error}</p>
            </div>
          )}
          {!loading &&
            !error &&
            projects.slice(0, 4).map((item, index) => (
              <div key={item.id ?? index} className="col-lg-6 items">
                <div className="item mt-50 wow fadeInUp" data-wow-delay=".2s">
                  <div className="img">
                    <a href={`/single-project/${item.id}`}>
                      <img src={item['Project Cover']} alt="" />
                    </a>
                  </div>
                  <div className="cont mt-30 d-flex align-items-center">
                    <div>
                      <span className="tag">{item['Project Title']}</span>
                    </div>
                    <div className="auto">
                      <div className="arrow">
                        <a href={`/single-project/${item.id}`}>
                          <svg
                            className="arrow-right"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 34.2 32.3"
                            xmlSpace="preserve"
                            style={{ strokeWidth: 2 }}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
